import { gql } from "apollo-angular";

export default gql`
  query Companies(
    $list: CompaniesList!
    $filter: CompaniesFilter!
    $registeredCountriesFilter2: RegisteredCountriesFilterInput
  ) {
    companies(list: $list, filter: $filter) {
      metaData {
        count
      }
      objects {
        id
        name
        countryCode
        partialExemption
        enabledProducts

        companySourceEntity
        vatNumber
        account {
          id
          name
        }
        createdAt
        contacts {
          name
          email
          phone
          mobile
          linkedIn
        }
        registeredCountries(filter: $registeredCountriesFilter2) {
          metaData {
            count
          }
          objects {
            countryCode
            vatNumber
            registrationPeriod {
              from
              to
            }
          }
        }
        address {
          addressType
          addressLine1
          addressLine2
          city
          region
          postalCode
          countryCode
        }
        partialExemptionType
        bankDetails {
          name
          accountNumber
          ibanNumber
          bankNumber
          sortCode
        }
        vatPortals {
          type
          id
        }
      }
    }
  }
`;
